import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmployerComponent } from './employer.component';
import { CreateEmployerProfileComponent } from './create-employer-profile/create-employer-profile.component';
import { EmployerDashboardModule } from './employer-dashboard/employer-dashboard.module';
import { RouterModule } from '@angular/router';
import { MatTabsModule, MatInputModule, MatFormFieldModule, MatSnackBarModule, MatRadioModule, MatAutocompleteModule, MatSelectModule, MatCheckboxModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from '../shared/shared.module';
import { FooterComponent } from '../shared/footer/footer.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';


@NgModule({
  declarations: [EmployerComponent],
  imports: [
    CommonModule,
    EmployerDashboardModule,
    RouterModule,
    MatTabsModule,
    FormsModule,
    MatInputModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSnackBarModule,
    MatAutocompleteModule,
    MatRadioModule,
    SharedModule,
    MatSelectModule,
    MatCheckboxModule,
    NgZorroAntdModule
  ]
})
export class EmployerModule { }
